import React from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  return (
    <div className="main-header">
      <div className="main-header-container">
        <h2 className="name nav-padding">
          <NavLink to="/">
            Nuno <br /> Gervasio
          </NavLink>
        </h2>
        <ul className="main-nav">
          <li className="nav-padding">
            <NavLink to="/projects" className="cool-link">
              Projects
            </NavLink>
          </li>
          <li className="nav-padding">
            <NavLink to="/contact" className="cool-link">
              Contact
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
